import { getDatabase, ref, set, serverTimestamp } from 'firebase/database';
import { OrderData } from '../context/CartContext';

export interface TrackOrderData extends OrderData {
  id: string;
  timestamp: number;
  tableInfo: {
    tableNumber: string;
    tableName: string;
  } | null;
}

export const trackOrder = async (orderData: TrackOrderData): Promise<void> => {
  const db = getDatabase();
  const orderRef = ref(db, `orders/${orderData.id}`);
  
  const cleanOrderData = Object.entries(orderData).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, unknown>);
  
  cleanOrderData.timestamp = serverTimestamp();
  
  await set(orderRef, cleanOrderData);
}; 